import {Brick, BrickContext, Query, registerBrick} from 'olympe';
import Assessment from '../../../models/Assessment';
import Observation from '../../../models/Observation';
import Unit from '../../../models/Unit';

export default class FetchAssessmentUnitsAndObservations extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} assessment
     * @param {function()} forwardEvent
     * @param {function(*)} setResult
     */
    async update($, [assessment], [forwardEvent, setResult]) {
        const units = await assessment.follow(Assessment.unitsRel).execute();

        const res = {};
        for (const unitTag of units.keys()) {
            const results = await Query.from(unitTag).follow(Unit.observationsRel).andReturn().follow(Observation.targetRel).andReturn().execute();
            res[unitTag] = results.reduce((map, [obs, entity]) => map.set(entity.getTag(), obs), new Map());
        }
        setResult(res);
        forwardEvent();
    }
}

registerBrick('018b144fc087111d8ad4', FetchAssessmentUnitsAndObservations);
